import React, { useState } from 'react';
import { TablePagination } from '@mui/material';
import { PAGE_SIZES } from './PagedTableBody';

// Pages any list of cards/items: renders `children(pageItems)` with at most 10 items, plus a
// "Rows per page · 1–10 of 45 · ‹ ›" bar underneath when there are more than 10. The page is
// kept in range when filtering shrinks the list.
//   <Paged items={offerings}>{rows => <Grid container>{rows.map(o => ...)}</Grid>}</Paged>
export default function Paged({ items, children, pageSize = PAGE_SIZES[0], label = 'Per page' }) {
  const list = items || [];
  const [page, setPage] = useState(0);
  const [perPage, setPerPage] = useState(pageSize);
  if (list.length <= pageSize) return children(list);

  const lastPage = Math.max(0, Math.ceil(list.length / perPage) - 1);
  const current = Math.min(page, lastPage);
  return (
    <>
      {children(list.slice(current * perPage, current * perPage + perPage))}
      <TablePagination
        component="div"
        count={list.length}
        page={current}
        rowsPerPage={perPage}
        rowsPerPageOptions={PAGE_SIZES}
        labelRowsPerPage={label}
        onPageChange={(_, p) => { setPage(p); }}
        onRowsPerPageChange={e => { setPerPage(Number(e.target.value)); setPage(0); }}
        // full width, so inside a Grid/flex list it sits on its own row under the items
        sx={{ width: '100%', flexBasis: '100%' }}
      />
    </>
  );
}
